import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CameraComponent from '../../../components/CameraComponent';
import SignatureComponent from '../../../components/SignatureComponent';
import DataTableComponent from '../../../components/DataTableComponent';
import FormikDemo from '../../../components/FormikDemo';

const Features = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('formik');

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  return (
    <div className="features-container">
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
          <span className="navbar-brand">KPM-Trizent Tab App</span>
          <div className="d-flex">
            <button
              className="btn btn-outline-light btn-sm me-2"
              onClick={() => navigate('/dashboard')}
            >
              Dashboard
            </button>
            <button
              className="btn btn-outline-light btn-sm"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="container mt-4">
        <h2 className="mb-4">Application Features</h2>

        {/* Tab Navigation */}
        <ul className="nav nav-tabs mb-4">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'formik' ? 'active' : ''}`}
              onClick={() => setActiveTab('formik')}
            >
              Formik Forms
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'datatable' ? 'active' : ''}`}
              onClick={() => setActiveTab('datatable')}
            >
              Data Table
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'camera' ? 'active' : ''}`}
              onClick={() => setActiveTab('camera')}
            >
              Camera
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'signature' ? 'active' : ''}`}
              onClick={() => setActiveTab('signature')}
            >
              Signature
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'formik' && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Formik Form Validation Demo</h5>
                <p className="text-muted mb-4">
                  Comprehensive form with various input types, validation rules, conditional fields, and dynamic field arrays using Formik + Yup.
                </p>
                <FormikDemo />
              </div>
            </div>
          )}

          {activeTab === 'datatable' && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">User Data Table</h5>
                <p className="text-muted">
                  Interactive data table with search, sort, and pagination features.
                </p>
                <DataTableComponent />
              </div>
            </div>
          )}

          {activeTab === 'camera' && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Camera Capture</h5>
                <p className="text-muted">
                  Capture photos using device camera. Works on mobile devices.
                </p>
                <CameraComponent
                  onCapture={(photo) => console.log('Photo captured:', photo)}
                />
              </div>
            </div>
          )}

          {activeTab === 'signature' && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Digital Signature</h5>
                <p className="text-muted">
                  Draw your signature on the canvas below.
                </p>
                <SignatureComponent
                  onSave={(signature) => console.log('Signature saved:', signature)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Features;
